<template>
  <div 
    class="model-card"
    :class="{ selected: selected }"
    @click="$emit('toggle')"
  >
    <div class="model-name">{{ model.name }}</div>
    <!-- <div class="model-description">{{ model.description }}</div> -->
    <!-- <div class="cost-info">
      <div class="cost-badge">{{ model.costPerRequest }}</div>
      <div class="speed-badge">{{ model.speed }}</div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'ModelCard',
  props: {
    model: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle']
}
</script>

<style scoped>
.model-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.model-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
}

.model-card.selected {
  border-color: #667eea;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.model-card.selected .cost-badge {
  background: rgba(255,255,255,0.2);
  color: white;
}

.model-name {
  font-size: 1.3em;
  font-weight: 600;
  margin-bottom: 10px;
}

.model-description {
  font-size: 0.9em;
  opacity: 0.8;
  margin-bottom: 15px;
}

.cost-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cost-badge {
  background: #f8f9fa;
  color: #495057;
  padding: 8px 12px;
  border-radius: 20px;
  font-size: 0.85em;
  font-weight: 600;
}

.speed-badge {
  background: #28a745;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75em;
  font-weight: 600;
}
</style>